import { atom } from 'jotai';

import type { CustomValidationError } from '@lib/errors/CustomValidationError';

export type TCustomError = {
  error?: Maybe<CustomValidationError>;
};

export const INITIAL_CUSTOM_ERROR_STATE = { error: null };

const customErrorAtom = atom<TCustomError>(INITIAL_CUSTOM_ERROR_STATE);

export { customErrorAtom };
